import { useNavigate, useParams } from "react-router-dom";
import { useTranslate } from "@tolgee/react";

import { VisitNoteForm } from "../../components/shared";

export const VisitNote = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslate();

  const handleSubmit = (values: { visitNote: string }) => {
    localStorage.setItem("visitNote|" + id, values.visitNote);
    navigate(-1);
  };

  return (
    <VisitNoteForm
      visitId={id ?? ""}
      onSubmit={handleSubmit}
      buttonText={t("save")}
    />
  );
};
